import React from 'react';
import { Hidden } from '@material-ui/core';
import { BeneficiarySettings } from './model/epi-props';

interface Props {    
    beneficiarySettings: BeneficiarySettings;   
    hasPercentages: boolean; 
}

export function BeneficiaryRowHeader(props: Props) {

    const { beneficiarySettings, hasPercentages } = props;

    return (
        <>
           
            <Hidden xsDown>
                { hasPercentages && <div className='benefit-table-header'><div><p><strong>{beneficiarySettings?.allocatedPercentageInformation}</strong></p></div></div> }
                <div className='benefit-table-row'>                
                    <div className='benefit-table-row-cell benefit-table-row-cell-name'>
                        <p className='input-label'>{beneficiarySettings?.nameColumnLabel}</p>
                    </div>                
                    <div className='benefit-table-row-cell'>
                        <p className='input-label'>{beneficiarySettings?.dateOfBirthColumnLabel}</p>
                    </div>                
                    <div className='benefit-table-row-cell'>
                        <p className='input-label'>{beneficiarySettings?.relationshipColumnLabel}</p>
                    </div>                
                    <div className='benefit-table-row-cell'>
                        <p className='input-label'>{beneficiarySettings?.statusColumnLabel}</p>
                    </div>                
                    { hasPercentages && <div className='benefit-table-row-cell'>
                        <p className='input-label'>{beneficiarySettings?.percentageColumnLabel}</p>
                    </div>}   
                    <div className='benefit-table-row-cell'>
                        <p className='input-label'>{beneficiarySettings?.actionColumnLabel}</p>
                    </div>                
                </div>
            </Hidden>        
        </>);
}
